module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoLayout mainLayout"
  }, [_c('section', {
    staticClass: "info"
  }, [_c('h1', [_vm._v("Maggiori informazioni")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "info-tech"
    }
  }, [_vm._v("Tecnologie")]), _vm._v(" "), _c('h3', [_vm._v("PWA")]), _vm._v(" "), _c('p', [_vm._v("Questo sito è una "), _c('a', {
    attrs: {
      "href": "https://developers.google.com/web/progressive-web-apps/",
      "target": "_blank"
    }
  }, [_vm._v("PWA")]), _vm._v("\n\t\tcome definito da Google ultimamente, ossia è una applicazione web con funzionalità aggiuntive:")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Funziona offline (parzialmenmte: i video non sono visibili da youtuibe mentre si è offline, ma si possono vedere l'elenco dei video e le loro miniature)")]), _vm._v(" "), _c('li', [_vm._v("Puo essere \"installata\" sul device attraverso la funzionalita \"add to homescreen\"")]), _vm._v(" "), _c('li', [_vm._v("Permette di essere caricata piu' velocemente")])])]), _vm._v(" "), _c('p', [_vm._v("Nota: \n\t\t\tla disponibilita' dei contenuti offline dipende anche dal browser in uso: consiglio di usare Chrome, \n\t\t\tOpera o Firefox alle ultime versioni per usufruire al meglio dei contenuti.\n\t\t")]), _vm._v(" "), _c('h3', [_vm._v("JAM")]), _vm._v(" "), _c('p', [_vm._v("Inotre utilizza lo stack JAM che consiste in 3 principali componenti:")]), _vm._v(" "), _c('p', [_c('ol', [_c('li', [_c('strong', [_vm._v("J")]), _vm._v(": javascript come linguaggio base")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("A")]), _vm._v(": API per passare informazioni ed interagire con la piattaforma")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("M")]), _vm._v(": Markup per creare i template che state vedendo")])])]), _vm._v(" "), _c('h3', [_vm._v("Hosting e sviluppo")]), _vm._v(" "), _c('p', [_vm._v("Questa web app è resa disponibile grazie a:")]), _vm._v(" "), _c('p', [_c('ol', [_c('li', [_c('strong', [_vm._v("Vuejs")]), _vm._v(": Framework javascript - "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Webpack")]), _vm._v(": Bundler javascript - "), _c('a', {
    attrs: {
      "href": "https://webpack.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Netlify")]), _vm._v(": Hosting html e file statici - "), _c('a', {
    attrs: {
      "href": "https://www.netlify.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Firebase Realtime db")]), _vm._v(": database usato per mostrare i video aggiunti dalla community - "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Firebase Cloud functions")]), _vm._v(": API permettere l'interazione con la web application: voti e aggiunta di video - "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e3dbad1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info.vue
// module id = 237
// module chunks = 2